import React, { useEffect, useState } from "react";
import { FaChartPie, FaChartBar, FaCubes, FaChartLine } from "react-icons/fa";
import { motion } from 'framer-motion'
import { Link } from "react-router-dom";
import { motionVariantsLeft, motionVariantsRight } from "../Common/MotionVarients";
import axios from "axios";

const WhyTechmentee = () => {
  const [services, setServices] = useState([]);

  const getAllService = async ()=>{
    try {
      const res = await axios.get(`${process.env.REACT_APP_BASE_URL}/services/get-all-service`);
      // console.log("Services",res.data.services);
      const firstFour = res.data.services.slice(1,5);
      setServices(firstFour);
    } catch (error) {
      console.log("Error Is Occured" , error);
    }
  }

  useEffect(()=>{
    getAllService();
  },[]);

  const motionVariants = [
    {
      hidden: { opacity: 0, y: -40 },
      visible: { opacity: 1, y: 0 },
    },
    {
      hidden: { opacity: 0, x: -100 },
      visible: { opacity: 1, x: 0 },
    },
    {
      hidden: { opacity: 0, x: 100 },
      visible: { opacity: 1, x: 0 },
    },
  ];

  const motionProperties = {
    initial: "hidden",
    whileInView: "visible",
    transition: { duration: 1, delay: 0.5 },
  }


  return (
    <React.Fragment>
      <div className="h-auto w-full lg:px-20 md:px-10 px-5 py-10 overflow-hidden">
        <div className="">
          <div className="flex flex-col justify-center items-center gap-4">
          <motion.div
              {...motionProperties}
              variants={motionVariantsLeft}
              className="text-[#7c96bd] text-[40px] font-bold tracking-wider text-center">
              Why Choose Techmentee
            </motion.div>
            <div className="flex justify-center items-center">
              <motion.p
                {...motionProperties}
                variants={motionVariantsRight}
                className="text-black text-[15px] tracking-wider md:w-[70%] w-full text-center">
                TECHMENTEE, headquartered in Alpharetta, Georgia, is a leading
                multinational IT Consulting company that has successfully served
                the business community for over five years in onshore and over
                Ten years in Offshore, since its incorporation,
              </motion.p>
            </div>

            <div className="grid lg:grid-cols-4 md:grid-cols-2 grid-cols-1  justify-center items-center md:gap-8 gap-4 mt-4">
              {services?.map((ele, index) => (
                <motion.div
                  key={index}
                  {...motionProperties}
                  variants={motionVariants[index % motionVariants.length]} // Apply different motion variant for each card
                  className="w-full h-full hover:shadow-2xl  transition duration-300 ease-linear bg-gray-200 rounded-lg flex flex-col gap-2 justify-between border p-6 hover:border-transparent"
                >
                  <div className="flex items-center justify-center">
                    {/* <div className="border rounded-full p-5">
                      {ele?.icon}
                    </div> */}
                    <img src={ele?.mainImage} alt={ele?.heading} />
                  </div>
                  <div>
                    <h1 className="text-[#626364] text-lg font-bold text-center">
                      {ele?.heading}
                    </h1>
                  </div>
                  <div>
                    <p className="text-[#626364] text-justify">
                      {ele?.introSection.subtitle}
                    </p>
                  </div>
                  <div className="flex items-center justify-center">
                    <Link to={`/serviceDetails/${ele._id}`} className="relative inline-flex items-center justify-center px-10 py-2 overflow-hidden font-mono font-medium tracking-tighter text-white bg-primaryOrangeColor rounded-lg group">
                      <span className="absolute w-0 h-0 transition-all duration-500 ease-out bg-primaryDarkColor rounded-full group-hover:w-56 group-hover:h-56"></span>
                      <span className="absolute inset-0 w-full h-full -mt-1 rounded-lg opacity-30 bg-gradient-to-b from-transparent via-transparent to-primaryOrangeColor"></span>
                      <span className="relative">
                        Read More
                      </span>
                    </Link>
                  </div>
                </motion.div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default WhyTechmentee;
